<script>
  export default {
    name: 'app-content-loader',
    props: {
      isLoading: {type: Boolean},
      message: {default: 'Carregando Dados', type: String}
    },
    data () {
      return {
        showLoading: true
      }
    },
    computed: {
      loading: function () {
        return this.isLoading
      }
    },
    watch: {
      loading: function (newValue, oldValue) {
        this.showLoading = oldValue === false && newValue === true
      }
    }
  }
</script>

<template>
    <div class="lds-loader" v-bind:class="{'-hidden': !showLoading}">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <span class="lds-text">{{message}}...</span>
    </div>
</template>

<style lang="scss" scoped>
    .lds-loader {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.75);
        opacity: 1;
        transition: all .3s ease-in-out;

        &.-hidden {
            z-index: -1;
            opacity: 0;
        }

        .lds-ring {
            display: inline-block;
            position: relative;
            width: 64px;
            height: 64px;
            div {
                box-sizing: border-box;
                display: block;
                position: absolute;
                width: 40px;
                height: 40px;
                margin: 6px;
                border: 6px solid #8F9E50;
                border-radius: 50%;
                animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
                border-color: #8F9E50 transparent transparent transparent;
                &:nth-child(1) {
                    animation-delay: -0.45s;
                }
                &:nth-child(2) {
                    animation-delay: -0.3s;
                }
                &:nth-child(3) {
                    animation-delay: -0.15s;
                }
            }
        }
        .lds-text {
            font-weight: 500;
            font-size: 13px;
        }
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>



// WEBPACK FOOTER //
// ContentLoader.vue?957e22fc